/* eslint-disable */
import * as Types from './schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetSubjectsDocument = gql`
    query GetSubjects {
  supportRequestSubjects {
    id
    name
  }
}
    `;

/**
 * __useGetSubjectsQuery__
 *
 * To run a query within a React component, call `useGetSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubjectsQuery, GetSubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubjectsQuery, GetSubjectsQueryVariables>(GetSubjectsDocument, options);
      }
export function useGetSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubjectsQuery, GetSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubjectsQuery, GetSubjectsQueryVariables>(GetSubjectsDocument, options);
        }
export function useGetSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubjectsQuery, GetSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubjectsQuery, GetSubjectsQueryVariables>(GetSubjectsDocument, options);
        }
export type GetSubjectsQueryHookResult = ReturnType<typeof useGetSubjectsQuery>;
export type GetSubjectsLazyQueryHookResult = ReturnType<typeof useGetSubjectsLazyQuery>;
export type GetSubjectsSuspenseQueryHookResult = ReturnType<typeof useGetSubjectsSuspenseQuery>;
export type GetSubjectsQueryResult = Apollo.QueryResult<GetSubjectsQuery, GetSubjectsQueryVariables>;
export const CreateSupportRequestDocument = gql`
    mutation createSupportRequest($input: SupportRequestInput!) {
  createSupportRequest(input: $input)
}
    `;
export type CreateSupportRequestMutationFn = Apollo.MutationFunction<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>;

/**
 * __useCreateSupportRequestMutation__
 *
 * To run a mutation, you first call `useCreateSupportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportRequestMutation, { data, loading, error }] = useCreateSupportRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupportRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>(CreateSupportRequestDocument, options);
      }
export type CreateSupportRequestMutationHookResult = ReturnType<typeof useCreateSupportRequestMutation>;
export type CreateSupportRequestMutationResult = Apollo.MutationResult<CreateSupportRequestMutation>;
export type CreateSupportRequestMutationOptions = Apollo.BaseMutationOptions<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>;
export type GetSubjectsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSubjectsQuery = { __typename?: 'Query', supportRequestSubjects?: Array<{ __typename?: 'SupportRequestSubjectProxyType', id: number, name: string }> | null };

export type CreateSupportRequestMutationVariables = Types.Exact<{
  input: Types.SupportRequestInput;
}>;


export type CreateSupportRequestMutation = { __typename?: 'Mutation', createSupportRequest: boolean };
